// TODO: Refactor to use local Radio component
import { Radio as RadioA } from 'antd';
import { useTranslation } from 'react-i18next';
import { Col } from '../../../col';
import { Row } from '../../../row';

export type Option<T> = {
  description?: string;
  key: T;
  title: string;
};

type P<T> = {
  checked: boolean;
  disabled?: boolean;
  onSelect: () => void;
  option: Option<T>;
};

const RadioOption = <T,>({ checked, disabled, onSelect, option }: P<T>) => {
  const { t } = useTranslation();

  return (
    <Row
      className={`radio-option-wrapper${checked ? ' radio-option-wrapper__active' : ''}${
        disabled ? ' radio-option-wrapper__disabled' : ''
      }`}
      onClick={
        disabled
          ? undefined
          : () => {
              onSelect();
            }
      }
    >
      <Col span={24}>
        <RadioA checked={checked} disabled={disabled}>
          {t(option.title)}
        </RadioA>
      </Col>
      {option.description ? (
        <Col className="radio-option-description" span={24}>
          {t(option.description)}
        </Col>
      ) : null}
    </Row>
  );
};

export default RadioOption;
